module.exports = __webpack_public_path__ + "static/Ryan Cheng@2x-162549170afbd459900a95b5b2f12a82.png";